import axios from 'axios';

const agapi = axios.create({
  baseURL: 'https://api.prd.brainymed.com/ag',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

(function checkAllowToken() {
  const params = new URLSearchParams(window.location.search);
  const allowToken = params.get('allowtoken');
  if (allowToken) {
    localStorage.setItem('auth', allowToken);
    console.log('[AG-API] Token captured from URL and saved to localStorage');
  }
})();

agapi.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('auth') || localStorage.getItem('auth'); 
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let isRefreshing = false;

const refreshAuthToken = async () => {
  try {
    const practiceId = process.env.REACT_APP_PRACTICE_ID || "1";
    const accessToken = localStorage.getItem('auth');
    // Use raw axios to avoid interceptor recursion
    const response = await axios.post(
      `https://api.prd.brainymed.com/ag/v1/${practiceId}/auth/refresh-token`,
      { "access_token": accessToken }
    );

    if (response && response.status === 200) {
      const newToken = response.data.refresh_token || response.data.token;
      localStorage.setItem('auth', newToken);
      return newToken;
    } else {
      // window.location.replace('/login');
      throw new Error('Failed to refresh token');
    }
  } catch (error) {
    console.error("[AG-API] Failed to refresh token:", error);
    throw error;
  }
};

agapi.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async (error) => {
    const originalRequest = error?.config;
    if (!originalRequest) return Promise.reject(error);

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      if (!isRefreshing) {
        isRefreshing = true;
        try {
          const newToken = await refreshAuthToken();
          if (newToken) {
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            isRefreshing = false;
            return agapi(originalRequest);
          }
        } catch (refreshError) {
          isRefreshing = false;
          return Promise.reject(refreshError);
        }
      }
    }
    return Promise.reject(error);
  }
);

export default agapi;
